import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    catchError,
    concatMap,
    map,
    switchMap,
    tap,
    throttleTime
} from 'rxjs/operators';
import * as fromShared from '../../../shared';
import { ResponseStatus } from '../../../shared';
import { IndirectRateService } from '../../indirect-rate.service';
import * as CostCenterActions from '../indirect-rate-cost-center/indirect-rate-cost-center.actions';
import * as IndirectRateStructureActions from './indirect-rate-structure.actions';

const log = new fromShared.Services.Logging.LoggingService();

@Injectable()
export class IndirectRateStructureEffects {
    getIndirectRateStructures$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateStructureActions.getIndirectRateStructures),
            switchMap(action => {
                log.verbose({
                    type: 'IndirectRateStructureEffects:getIndirectRateStructures$',
                    action
                });
                // if (!!action.Ratetype) {
                return this.service
                    .post({
                        FYenddate: action.FiscalYear,
                        Ratetype: action.Ratetype
                    })
                    .pipe(
                        map(indirectRateStructures =>
                            IndirectRateStructureActions.loadIndirectRateStructures(
                                {
                                    indirectRateStructures
                                }
                            )
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    );
                // } else {
                //     return this.service.get(action.FiscalYear).pipe(
                //         map(indirectRateStructures =>
                //             IndirectRateStructureActions.loadIndirectRateStructures(
                //                 {
                //                     indirectRateStructures
                //                 }
                //             )
                //         ),
                //         catchError(fromShared.Errors.handleServiceError)
                //     );
                // }
            })
        );
    });
    getIndirectRateTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateStructureActions.getIndirectRateTypes),
            throttleTime(5000), // multiple pieces of indirect rate structure use this, but only the first one in needs to make the API call
            switchMap(() => {
                return this.service.getIndirectRateTypes().pipe(
                    map(indirectRateTypes =>
                        IndirectRateStructureActions.loadIndirectRateTypes({
                            indirectRateTypes
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                );
            })
        );
    });
    putIndirectRateStructures$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateStructureActions.putIndirectRateStructures),
            tap(action =>
                log.verbose({
                    type: 'IndirectRateStructureEffects:putIndirectRateStructures$',
                    action
                })
            ),
            switchMap(action =>
                this.service.put(action.indirectRateStructures).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  IndirectRateStructureActions.upsertIndirectRateStructures(
                                      {
                                          indirectRateStructures: resp.Items
                                      }
                                  ),
                                  IndirectRateStructureActions.deleteIndirectRateStructures(
                                      {
                                          ids: resp.Items.filter(
                                              x => x.Ratepercent === 0
                                          ).map(x => x.id)
                                      }
                                  ),
                                  CostCenterActions.getIndirectRateCostCenters(),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.id.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  IndirectRateStructureActions.upsertIndirectRateStructures(
                                      {
                                          indirectRateStructures: resp.Items
                                      }
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    removeIndirectRateStructures$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateStructureActions.removeIndirectRateStructures),
            switchMap(action =>
                this.service.delete(action.indirectRateStructures).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  IndirectRateStructureActions.deleteIndirectRateStructures(
                                      {
                                          ids: action.indirectRateStructures.map(
                                              x => x.id
                                          )
                                      }
                                  ),
                                  CostCenterActions.getIndirectRateCostCenters(),
                                  new fromShared.Errors.RemoveErrors(
                                      action.indirectRateStructures.map(x =>
                                          x.id.toString()
                                      )
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  IndirectRateStructureActions.upsertIndirectRateStructures(
                                      {
                                          indirectRateStructures: resp.Items
                                      }
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: IndirectRateService
    ) {}
}
